import React, { useState } from 'react';
import { Card, Button, Table, Badge, Spinner, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useQuery, useMutation } from 'react-query';
import { BAOVELUANANCOSO_API } from '@app/utils/apiUrl';
import { trangThaiBaoVeCoSoValue } from '@app/utils/define';
import { Get, DeleteSingle } from '@app/utils/httpProvider';
import moment from 'moment';
import { toast } from 'react-toastify';
import { ConfirmModal } from '@app/modules/modal/ConfirmModal';
import BaoVeCoSoAdd from './BaoVeCoSoAdd';
import BaoVeCoSoEdit from './BaoVeCoSoEdit';
import QuyetDinhBaoVeModal from './QuyetDinhBaoVeModal';

const BaoVeCoSo = ({ hoSoId }) => {
    const [viewMode, setViewMode] = useState('list');
    const [dataEdit, setDataEdit] = useState(null);
    
    // Delete state
    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    
    const { isLoading, data: queryData, refetch } = useQuery(
        ['baoVeCoSoData', hoSoId],
        () => Get(`${BAOVELUANANCOSO_API.GET_BY_HOSO_ID}/${hoSoId}`),
        { 
            enabled: !!hoSoId,
            keepPreviousData: true
        }
    );

    let dataList = [];
    if (queryData) {
        if (Array.isArray(queryData)) {
            dataList = queryData;
        } else if (queryData.data && Array.isArray(queryData.data)) {
            dataList = queryData.data;
        } else if (queryData.data?.$values) {
            dataList = queryData.data.$values;
        } else {
            dataList = [queryData];
        }
    }

    const deleteFunc = useMutation((id) => DeleteSingle(BAOVELUANANCOSO_API.DELETE_ITEM, id, null));

    const deleteAction = (id) => {
        setIdWantDelete(id);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = () => {
        if (!idWantDelete) return;

        deleteFunc.mutate(idWantDelete, {
            onSuccess: (res) => {
                if (res && (res.status === 200 || res.status === 201 || res.status === 204 || res.success)) {
                    toast.success('Xóa thành công');
                    refetch();
                } else {
                    toast.error(res?.message || 'Có lỗi xảy ra khi xóa');
                }
            },
            onError: (err) => {
                toast.error(err?.message || 'Có lỗi xảy ra');
            }
        });

        setOpenConfirmDeleteModal(false);
        setIdWantDelete('');
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    const renderTooltip = (props, text) => (
        <Tooltip id="button-tooltip" {...props}>
            {text}
        </Tooltip>
    );

    const renderTrangThai = (val) => {
        switch (val) {
            case trangThaiBaoVeCoSoValue.choQuyetDinh: return <Badge variant="warning">Chờ quyết định</Badge>;
            case trangThaiBaoVeCoSoValue.choBaoVe: return <Badge variant="info">Chờ bảo vệ</Badge>;
            case trangThaiBaoVeCoSoValue.hoanThanh: return <Badge variant="success">Hoàn thành</Badge>;
            default: return <Badge variant="secondary">Chưa xác định</Badge>;
        }
    };

    return (
        <>
        <Card className="h-100">
            <Card.Header>
                <div className="d-flex justify-content-between align-items-center">
                    <h5 className="font-weight-bold text-primary m-0">Bảo vệ luận án cơ sở</h5>
                    <Button variant="success" size="sm" onClick={() => setViewMode('add')}>
                        <i className="fas fa-plus mr-1"></i> Thêm mới
                    </Button>
                </div>
            </Card.Header>
            <Card.Body>
                {isLoading ? (
                    <div className="text-center p-5">
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : (
                    <>
                        <div className="table-responsive">
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th className="text-center" width="50">STT</th>
                                        <th className="text-center">Ngày bảo vệ dự kiến</th>
                                        <th className="text-center">Trạng thái</th>
                                        <th className="text-center" width="120">Thao tác</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dataList && dataList.length > 0 ? (
                                        dataList.map((item, index) => (
                                            <tr key={item.id}>
                                                <td className="text-center">{index + 1}</td>
                                                <td className="text-center">
                                                    {item.ngayBaoVe ? moment(item.ngayBaoVe).format('DD/MM/YYYY') : ''}
                                                </td>
                                                <td className="text-center">{renderTrangThai(item.trangThai)}</td>
                                                <td className="text-center">
                                                    <div className="d-flex justify-content-center text-nowrap">
                                                        <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Sửa')}>
                                                            <Button 
                                                                variant="warning" 
                                                                size="sm" 
                                                                className="mr-1 text-white"
                                                                onClick={() => { setDataEdit(item); setViewMode('edit'); }} 
                                                                disabled={item.trangThai !== trangThaiBaoVeCoSoValue.choQuyetDinh}
                                                            >
                                                                <i className="fas fa-edit"></i>
                                                            </Button>
                                                        </OverlayTrigger>
                                                        <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Xóa')}>
                                                            <Button 
                                                                variant="danger" 
                                                                size="sm"
                                                                className="mr-1"
                                                                onClick={() => deleteAction(item.id)}
                                                                disabled={item.trangThai !== trangThaiBaoVeCoSoValue.choQuyetDinh}
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </Button>
                                                        </OverlayTrigger>
                                                        <OverlayTrigger placement="top" overlay={(props) => renderTooltip(props, 'Quyết định bảo vệ')}>
                                                            <Button 
                                                                variant="primary" 
                                                                size="sm" 
                                                                onClick={() => { setDataEdit(item); setViewMode('quyetDinhBaoVe'); }}
                                                            >
                                                                <i className="fas fa-check-double"></i>
                                                            </Button>
                                                        </OverlayTrigger>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4" className="text-center text-muted">
                                                Chưa có dữ liệu Bảo vệ luận án cơ sở
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                        <ConfirmModal
                            isOpen={openConfirmDeleteModal}
                            confirmType="delete"
                            goBackAfterDelete={false}
                            handleAccept={acceptDelete}
                            handleCancel={cancelDelete}
                            content="Bản ghi này"
                        />
                    </>
                )}
            </Card.Body>
        </Card>

        {viewMode === 'add' && <BaoVeCoSoAdd hoSoId={hoSoId} setViewMode={setViewMode} refreshList={refetch} />}
        {viewMode === 'edit' && dataEdit && <BaoVeCoSoEdit hoSoId={hoSoId} dataEdit={dataEdit} setViewMode={setViewMode} refreshList={refetch} />}
        {viewMode === 'quyetDinhBaoVe' && dataEdit && (
            <QuyetDinhBaoVeModal
                dataEdit={dataEdit}
                setViewMode={setViewMode}
                isView={true}
                isUserView={true}
            />
        )}
        </>
    );
};

export default BaoVeCoSo;
